import { useContext } from "react";
import Context from "../../../../context";
import {
  CustomBadges,
  CustomIcon,
  TableNullData,
  UserInformation,
} from "../../../../components";
import { ICreateAndUpdateCompany } from "../../../../types/company.interface";

const Body = (data: any) => {
  const { resultCompany, setSelectedCompany, setShowModal } = useContext(
    Context.CompanyScreen
  );

  const companies = resultCompany?.data?.result?.docs;

  const onDetail = (company: ICreateAndUpdateCompany) => {
    setSelectedCompany!(company);
    setShowModal!("DETAIL");
  };
  const onUpdate = (company: ICreateAndUpdateCompany) => {
    setSelectedCompany!(company);
    setShowModal!("UPDATE");
  };
  const onDelete = (company: ICreateAndUpdateCompany) => {
    setSelectedCompany!(company);
    setShowModal!("DELETE");
  };

  if (companies?.length <= 0 || !data) return <TableNullData />;
  return (
    <tbody id="driver-table-body-container">
      {companies?.map((company: any, index: number) => {
        return (
          <tr key={`driver-${index}`}>
            <td className="pointer">
              <UserInformation
                name={company?.name}
                phoneNumber={company?.address}
                hideAvatar
              />
            </td>
            <td className="pointer">
              <UserInformation
                avatar={company?.avatar}
                name={company?.firstName}
                lastName={company?.lastName}
                phoneNumber={company?.phoneNumber}
              />
            </td>
            <td>
              <CustomBadges
                title={company?.cities?.map((item: any, index: number) =>
                  index + 1 !== company?.cities?.length
                    ? item?.name + "-"
                    : item?.name
                )}
              />
            </td>
            <td className="pointer">
              <CustomBadges
                title={
                  company?.isCompleteRegistration ? "تکمیل شده" : "تکمیل نشده"
                }
                type={company?.isCompleteRegistration ? "success" : "danger"}
              />
            </td>
            {/* Status */}

            {/* actions */}
            <td>
              <div className="table-actions-buttons">
                {/* Edit Icon */}
                <CustomIcon
                  icon="fas fa-location-dot"
                  hoverTitle="موقعیت مکانی"
                  onClick={() => onDetail(company)}
                />
                <CustomIcon
                  icon="fas fa-pen"
                  hoverTitle="ویرایش"
                  onClick={() => onUpdate(company)}
                />
                <CustomIcon
                  icon="fas fa-trash"
                  hoverTitle="حذف"
                  onClick={() => onDelete(company)}
                />
              </div>
            </td>
          </tr>
        );
      })}
    </tbody>
  );
};

export default Body;
